import { useFormik } from "formik";
import { useEffect } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import TextValidator from "../../components/input/text-validator";
import { RESPONSE_STATUS_CODE, VARIABLE_STRING } from "../../constants/moduleConsts";
import { INIT_SOLDIER, REF_TAB } from "../constants/profileConsts";
import { addSoldier, getSoldier } from "../services/profileServices";
import useMultiLanguage from "../../../hook/useMultiLanguage";
import { EmployeeProfile, ISoldier } from "../models/profileModels";
import { getFullYear, numberExceptThisSymbols } from "../../utils/functionUtils";
import Autocomplete from "../../components/input/autocomplete";

interface IProps {
  identify: string;
  isView: boolean;
  employeeProfiles: EmployeeProfile;
  formikRef: any;
  activeTab: string;
  handleToggleIsView: () => void;
};

const SoldierInformation = (props: IProps) => {
  const { lang } = useMultiLanguage();
  const { identify, employeeProfiles, isView, activeTab, formikRef, handleToggleIsView } = props;

  useEffect(() => {
    if (identify && activeTab === REF_TAB.THONG_TIN_CHIEN_SI) {
      updateSoldierInfo();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employeeProfiles, activeTab]);

  const updateSoldierInfo = async () => {
    try {
      const { data } = await getSoldier(identify);
      if (data?.code === RESPONSE_STATUS_CODE.SUCCESS) {
        formik.setValues({ ...formik.values, ...data?.data });
      } else {
        toast.warning(data?.message);
      }
    } catch (error) {
      toast.error(lang("GENERAL.ERROR"));
    }
  };

  const handleFormSubmit = async (values: ISoldier) => {
    try {
      const dataSubmit = { ...values, employeeId: identify };
      const { data } = await addSoldier(identify, dataSubmit);
      if (data?.code === RESPONSE_STATUS_CODE.SUCCESS) {
        let message = values?.id ? lang("TOAST.EDIT.SUCCESS") : lang("TOAST.CREATE.SUCCESS");
        formik.setFieldValue("id", data?.data?.id);
        toast.success(message);
        handleToggleIsView();
      } else {
        toast.warning(data?.message);
      }
    } catch (error) {
      toast.error(lang("GENERAL.ERROR"));
    }
  };

  const formik = useFormik({
    initialValues: INIT_SOLDIER,
    onSubmit: handleFormSubmit
  });

  useEffect(() => {
    if (formikRef) {
      formikRef.current = formik;
    }
  }, [formik, formikRef]);
  
  const handleChangeSelect = (name: string, value: any) => {
    formik.setFieldValue(name, value);
  };

  return (
    <Form
      className="form-info"
      onSubmit={formik.handleSubmit}
    >
      <div className="block-content">
        <span className="spaces fs-18 fw-600">{lang("INPUT.SOLDIER.TITLE")}</span>
        <Row>
          <Col xs={12} md={6} lg={4} xl={3} className="mt-3">
            <Autocomplete
              lable={lang("INPUT.SOLDIER.DATE_JOIN")}
              options={getFullYear(0, 100)}
              value={formik.values?.namVaoNganh ? String(formik.values?.namVaoNganh) : null}
              name={VARIABLE_STRING.NAM_VAO_NGANH}
              isReadOnly={isView}
              onChange={(selectedOption) => handleChangeSelect(VARIABLE_STRING.NAM_VAO_NGANH, selectedOption?.name)}
            />
          </Col>
          <Col xs={12} md={6} lg={4} xl={3} className="mt-3">
            <TextValidator
              lable={lang("INPUT.SOLDIER.POLITICAL_QUALIFICATION")}
              name="trinhDoChinhTri"
              value={formik?.values?.trinhDoChinhTri || ""}
              type="text"
              readOnly={isView}
              onChange={formik.handleChange}
            />
          </Col>
          <Col xs={12} md={6} lg={4} xl={3} className="mt-3">
            <TextValidator
              lable={lang("INPUT.SOLDIER.PROFESSIONAL_QUALIFICATION_OF_POLICE")}
              name="trinhDoNghiepVu"
              value={formik?.values?.trinhDoNghiepVu || ""}
              type="text"
              readOnly={isView}
              onChange={formik.handleChange}
            />
          </Col>
          <Col xs={12} md={6} lg={4} xl={3} className="mt-3">
            <TextValidator
              type="text"
              lable={lang("INPUT.SOLDIER.POSITION")}
              name="chucVu"
              value={formik?.values?.chucVu || ""}
              readOnly={isView}
              onChange={formik.handleChange}
            />
          </Col>
          <Col xs={12} md={6} lg={4} xl={3} className="mt-3">
            <TextValidator
              type="text"
              lable={lang("INPUT.SOLDIER.OFFICER")}
              name="siQuan"
              value={formik?.values?.siQuan || ""}
              readOnly={isView}
              onChange={formik.handleChange}
            />
          </Col>
          <Col xs={12} md={6} lg={4} xl={3} className="mt-3">
            <TextValidator
              type="text"
              lable={lang("INPUT.SOLDIER.CAND")}
              name="soHieuCAND"
              value={formik?.values?.soHieuCAND || ""}
              readOnly={isView}
              onChange={formik.handleChange}
            />
          </Col>
          <Col xs={12} md={6} lg={4} xl={3} className="mt-3">
            <TextValidator
              name="heSoLuong"
              lable={lang("SALARY.COEFFICIENT")}
              readOnly={isView}
              type="number"
              value={formik.values?.heSoLuong}
              onChange={formik.handleChange}
              onKeyDown={numberExceptThisSymbols}
            />
          </Col>
        </Row>
      </div>
    </Form>
  );
};

export default SoldierInformation;
